module.exports = __webpack_public_path__ + "static/media/m9.8ec81bc3.jpg";